var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrainingButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 228,
    height: 159,
    viewBox: "0 0 228 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.251 120.806C187.794 109.537 208.164 92.5068 217.025 87.464C226.179 82.254 226.868 87.3665 226.917 90.2501C227.001 95.1257 226.833 98.1626 226.854 103.338C226.917 116.516 224.535 116.976 224.535 116.976C218.049 123.021 168.588 157.896 168.588 157.896C168.588 157.896 164.931 131.839 176.251 120.806Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3858 127.847C73.3858 127.847 72.6056 112.523 73.3858 110.065C75.218 104.207 82.0241 102.271 85.0823 101.637",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.588 157.896L88.5933 126.205C87.8401 125.955 87.0241 125.97 86.2804 126.246L86.1899 126.281C85.3711 126.611 84.712 127.245 84.3508 128.05C83.1526 130.53 75.7613 135.12 73.2952 134.911C71.6721 134.779 53.6083 125.418 44.3292 119.455C40.3723 116.913 42.5318 97.8632 44.8098 93.2871C48.5299 85.8761 59.6063 76.6611 64.023 72.9277",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.497 40.1758C144.776 42.9619 156.786 47.8027 156.577 49.0495C156.326 50.547 151.819 51.2923 151.952 51.7938C152.084 52.2953 202.353 72.2158 219.142 78.8815C221.389 79.7685 223.325 81.2993 224.705 83.2819C226.086 85.2645 226.85 87.6106 226.902 90.0258V90.2417",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9385 44.9004C78.9385 44.9004 83.2158 53.4188 89.9035 48.5502C91.2163 47.6474 92.5948 46.8442 94.0276 46.1471",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0264 119.497L102.045 115.75L162.652 139.947",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M126.852 74.2441C117.963 77.8173 105.737 75.0939 103.285 74.2441",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M173.681 108.289C173.681 108.289 154.927 101.045 141.155 95.0548C139.148 94.1772 138.487 92.0319 138.264 90.4229C136.634 78.582 155.631 72.0626 164.241 74.4865C169.556 75.984 193.228 84.9343 202.897 88.0896",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6539 72.2588C63.6539 72.2588 60.2752 65.0776 52.3127 65.7463C49.8536 65.9483 44.5034 71.6389 41.0899 71.3185C17.9129 69.3891 6.54385 56.3363 3.06068 46.8218C0.0930223 38.7212 -0.422505 24.9231 6.6553 14.8514C11.5317 7.9698 19.1041 -1.11981 36.6106 1.44339C46.6212 2.90608 53.7408 11.9469 60.0244 14.1271C76.9387 19.9778 82.5675 32.2366 78.952 44.8646",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4004 27.8002C51.4004 27.8002 54.1242 21.8032 56.869 20.5703",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4355 27.8903C27.4355 27.8903 28.369 18.3828 37.8851 18.6196",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6787 14.8242C42.6787 14.8242 45.8414 8.06096 52.0484 9.25201",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1982 32.9688C60.1982 32.9688 62.3508 25.6762 68.0075 27.2364",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5488 18.3809C50.3619 20.2127 53.1484 18.6386 56.9799 19.9202C56.9799 19.9202 59.5366 20.2684 57.6278 24.956",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6783 23.8848C42.6783 23.8848 35.9348 24.1982 35.7119 31.1286",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0911 14.8304C59.0911 14.8304 51.9227 14.5796 50.1045 19.3439",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2315 40.7684C24.2315 40.7684 15.5166 36.4499 15.7813 44.251C15.9276 48.4301 21.849 49.9903 24.3778 51.7804C32.5005 57.5406 32.7374 47.1624 32.7374 47.1624",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5915 39.5777C19.5915 39.5777 14.6314 36.9449 15.753 31.5886C16.8746 26.2324 19.4939 15.9656 27.4286 13.5278C35.3632 11.09 44.9768 4.06206 39.968 2.24414",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.7441 47.1758C32.7441 47.1758 41.87 48.1857 40.5743 53.9111C38.4844 63.0356 49.8604 65.9331 49.8604 65.9331",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M156.578 49.0508V53.808",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M155.826 84.2871L185.684 96.2116",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M157.644 92.0179L170.754 82.9004",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M169.675 96.5734L182.792 87.4629",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8564 53.8431C51.4068 54.4979 64.5592 61.6999 67.1925 55.5635C67.1925 55.5635 67.088 42.462 71.3723 38.7286C73.8245 36.5833 78.8681 33.9923 78.9656 44.8998",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M141.14 55.6055L115.065 66.4642L88.9971 55.6055",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M141.14 59.7422L115.065 70.601L88.9971 59.7422",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M128.434 56.8877V48.4668H101.704V56.8877",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M101.516 42.7539H128.622",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M101.516 37.3926H128.622",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingButton);
export default __webpack_public_path__ + "static/media/trainingButton.f09fa2d1.svg";
export { ForwardRef as ReactComponent };